import { render, staticRenderFns } from "./GGBtn.vue?vue&type=template&id=317c3020&"
import script from "./GGBtn.vue?vue&type=script&lang=js&"
export * from "./GGBtn.vue?vue&type=script&lang=js&"
import style0 from "./GGBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('317c3020')) {
      api.createRecord('317c3020', component.options)
    } else {
      api.reload('317c3020', component.options)
    }
    module.hot.accept("./GGBtn.vue?vue&type=template&id=317c3020&", function () {
      api.rerender('317c3020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Global/GGBtn.vue"
export default component.exports